"use strict";

var _ = require("underscore");
var Reflux = require("reflux");
var UserSelectBoxActions = require("../actions/user-select-box-actions.js");
var MultiActionStore = require("app/util/flux/multi-action-store");
var KeyNavigatorStoreMixin = require("app/util/browser/key-navigator").storeMixin;

function createStore(instaceKey){
  var userSelectBoxActions = UserSelectBoxActions(instaceKey);

  var store = Reflux.createStore({
    mixins: [KeyNavigatorStoreMixin],
    state: {
      focusIndex: -1,
      focusId: -1,
      users: []
    },
    setState: function(state){
      this.state = _.defaults(state, this.state);
      this.trigger(this.state);
      return this.state;
    },
    getInitialState: function() {
      return {
        focusIndex: -1,
        focusId: -1,
        users: []
      };
    },
    init: function(){
      this.listenTo(userSelectBoxActions.check, this.onCheck);
      this.listenTo(userSelectBoxActions.search, this.onSearch);
      this.listenTo(userSelectBoxActions.focusUser, this.onFocusUser);
      this.listenTo(userSelectBoxActions.loadUsers.completed, this.onLoadUsersCompleted);
      this.listenTo(userSelectBoxActions.populate, this.onPopulate);
      this.listenTo(userSelectBoxActions.keyNavigate, this.onKeyNavigate);

      this.state = this.getInitialState();
    },
    onPopulate: function(userSelectBox){
      this.setState(userSelectBox);
    },
    onCheck: function(id, checked){
      var user = _.find(this.state.users, function(u){return u.id==id;});
      if(user){
        user.checked = checked;
        this.trigger(this.state);
      }
    },
    onSearch: function(query){
      if(query){
        query = query.toLowerCase();
        _.each(this.state.users, function(user){
          var hasOnName, hasOnPosition = false;

          if (user.name) {
            hasOnName = (user.name.toLowerCase().indexOf(query)!=-1);
          }
          if (user.position) {
             hasOnPosition = (user.position.toLowerCase().indexOf(query)!=-1);
          }

          user.hidden = (!hasOnName&&!hasOnPosition);
        });
      } else {
        _.each(this.state.users, function(user){
          user.hidden = false;
        });
      }
      this.state.focusId = null;
      this.state.focusIndex = -1;
      this.trigger(this.state);
    },
    onKeyNavigate: function (keyCode) {
      var shownUsers = _.filter(this.state.users, function(user){
        return !user.hidden;
      });

      // The navigate method is defined in KeyNavigatorStoreMixin
      this.navigate(keyCode, shownUsers);
    },
    enterPressed: function (user) {
      if(user){
        user.checked = !user.checked;
        this.trigger(this.state);
      }
    },
    escPressed: function (user) {
      if(user){
        user.checked = false;
        this.trigger(this.state);
      }
    },
    onFocusUser: function(id){
      this.state.focusId = id;
      this.trigger(this.state);
    },
    onLoadUsersCompleted: function(users, selectedUsers){
      _.each(users, function(user, i){
        user.checked = (
          _.find(selectedUsers, function(su){ return su.id == user.id; } )
        );
        if (user.id == window.loggedUserId) {
          users.splice(i, 1);
          users.unshift(user);
        }
      });
      this.state.users = users;
      this.trigger(this.state);
    },
  });

  return store;
}

module.exports = MultiActionStore.factory(createStore);



// WEBPACK FOOTER //
// ./app/screens/Activity/stores/user-select-box-store.js